import { ref, computed } from "vue";

export const usePagination = (resources, customItemsPerPage) => {
  const itemsPerPage = ref(customItemsPerPage);
  const currentPage = ref(1);

  const totalPages = computed(() => Math.ceil(resources.value.length / itemsPerPage.value));

  const paginationRange = computed(() => {
    const total = totalPages.value;
    const current = currentPage.value;
    const delta = 2;

    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const range = [];
    range.push(1);

    if (current > delta + 2) {
      range.push("...");
    }

    const start = Math.max(2, current - delta);
    const end = Math.min(total - 1, current + delta);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (current < total - delta - 1) {
      range.push("...");
    }

    range.push(total);
    return range;
  });

  const paginatedResources = computed(() => {
    const start = (currentPage.value - 1) * itemsPerPage.value;
    return resources.value.slice(start, start + itemsPerPage.value);
  });

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages.value) {
      currentPage.value = page;
    }
  };

  const goToNextPage = () => {
    if (currentPage.value < totalPages.value) {
      currentPage.value++;
    }
  };

  const goToPreviousPage = () => {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  };

  return {
    paginatedResources,
    paginationRange,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    totalPages,
    currentPage
  };
};
